import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Home.css";
import { Spinner } from "../Spinner";
import { useSettings } from "../Context/SettingsContext";
import ReactPixel from 'react-facebook-pixel';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function Home(){

    const [categories, setCategories] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = React.useState(null);
    const settings = useSettings();
    const query = useQuery();
    const source = query.get("s");

    useEffect(() => {

        const fetchCategories = async () => {
          try {

            setLoading(true);
            setError(null);

            const response = await fetch(`${settings.ApiUrl}/Category/GetCategories`);

            if (!response.ok){
              setError('Ha ocurrido un problema al obtener los productos. Intenta más tarde.');
            }
          else{
              const data = await response.json();
              setCategories(data);              
            }          

          } catch (err) {
            setError(err.message);   
            setCategories([]);
            
          } finally {
            setLoading(false);
          }

        };
    
        fetchCategories();

      }, []);

    useEffect(() => {

      ReactPixel.trackCustom('ViewHome');      
     
      try {
        fetch(`${settings.ApiUrl}/View/AddView`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            source,
            page: "home"
          })
        });
      } catch (error) {
        console.error("Error al registrar la visita:", error);
      }          
      
    }, []);

      const sliderSettings = {
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: true,
        dots: true, 
        infinite: true,
        speed: 500, 
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 640, 
                settings: {
                  slidesToShow: 3,
                },
              },
          {
            breakpoint: 768, 
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 1536, 
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      };

      if (error) {
        return (
        <div className="error-message">          
            <p>Por favor, inténtalo de nuevo más tarde.</p>
        </div>
        );
      }


    return (
        <div className="home-container">
          <div className="brand-description">
            <h1>{settings.WelcomeTitle}</h1>
            <p>{settings.WelcomeMessage}</p>
            <button className="view-all-button" onClick={() => navigate("/All")}>
              Ver todo
            </button>
          </div>
          
          <div className="category-container">
            <h2 className="category-list-title">Categorías</h2>
            {loading
              ?
              <Spinner></Spinner>              
              :
              <Slider {...sliderSettings}>
              {categories.map((category) => (
                <div key={category.id} className="category-card" onClick={() => navigate(`/category/${category.id}`)}>
                  <div className="category-image-container">
                      <img src={category.imageUrl} alt={category.name} className="category-image" loading="eager"/>
                  </div>
                  <p className="category-name">{category.name}</p>
                </div>
              ))}
            </Slider>
            }

          </div>
        </div>
      );

}

export { Home };